import svgPaths from '../../../assets/imports/PgrmLandingPageDeslogada/svg-huqtkssm9g';
import imgHeroImage from '../../../assets/data_center.png';
import { useInView } from '../../../hooks/useInView';
import { lojaSerpro } from '../../../environment/environment';
import styles from './LojaSerproBanner.module.scss';

export function LojaSerproBanner() {
  const [ref, inView] = useInView<HTMLDivElement>();

  const lojaHabilitada = lojaSerpro.habilitada === 'true';
  const lojaUrl = lojaSerpro.url;

  if (!lojaHabilitada) return null;

  return (
    <div className={styles.wrapper} data-name='loja-serpro-banner'>
      <div ref={ref} className={`${styles.banner} ${inView ? 'inView' : ''}`}>
        <div className={styles.content}>
          <div className={styles.badge}>
            <p>Campanha</p>
          </div>
          <p className={styles.title}>Conecte seu sistema à PGRM</p>
          <p className={styles.desc}>
            Automatize declarações e guias de recolhimento, reduza o retrabalho
            e ganhe mais agilidade na sua operação.
          </p>
          <button
            className={styles.cta}
            onClick={() =>
              lojaUrl && window.open(lojaUrl, '_blank', 'noopener')
            }
            type='button'
          >
            <span>Conhecer a Loja</span>
            <svg
              className={styles.arrow}
              fill='none'
              height='18'
              viewBox='0 0 18 18'
              width='18'
            >
              <path
                d={svgPaths.p394a7400}
                stroke='white'
                strokeLinecap='round'
                strokeWidth='2'
              />
            </svg>
          </button>
        </div>
        <div className={styles.imageWrap}>
          <img alt='' className={styles.image} src={imgHeroImage} />
          <div className={styles.imageFade} />
        </div>
      </div>
    </div>
  );
}
